import { Box, Fab, Typography } from '@mui/material'
import { Info } from '@mui/icons-material'
import { TpTooltip } from '~/components/tp-tooltip'

const LEAVE_DELAY = 500

export const PlotHelpTooltip = () => {
  return (
    <TpTooltip
      title={
        <Box>
          <Typography>
            Plots are used to define <strong>larger areas</strong> and can contain many beds or crop rows.
            <br />
            <strong>Or—</strong> if you don&apos;t have many crop rows, you can still use plots to represent a <strong>single bed</strong> if you like!
          </Typography>
        </Box>
      }
      placement="top"
      enterTouchDelay={0}
      followCursor={false}
      leaveTouchDelay={LEAVE_DELAY}
      leaveDelay={LEAVE_DELAY}
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -12],
              },
            },
          ],
        },
      }}
    >
      <Fab
        size="small"
        disableRipple
        disableFocusRipple
        tabIndex={-1}
        sx={{
          position: 'absolute',
          top: 14,
          right: 16,
          bgcolor: 'background.paper',
          boxShadow: 'none',
          pointerEvents: 'hover',
          cursor: 'unset',
          '&:active': {
            boxShadow: 'none',
            bgcolor: 'background.paper',
          },
          '&:hover': {
            bgcolor: 'background.paper',
          }
        }}
      >
        <Info color='primary' />
      </Fab>
    </TpTooltip>
  )
}
